export default __webpack_public_path__ + "static/media/technician.2c1d03a2.png";